export default __webpack_public_path__ + "092d0eda0e67ab979705c78e98d0b348.png";